import { AgentWithDetails } from "../agents/types";

// Interface for Agent from API
export interface AgentItem {
  id: number;
  microsoftId: string;
  displayName: string;
}

export interface AgentDetail {
  queueName: string;
  totalHandledCalls: number;
  totalAnsweredDuration: number;
  averageHandleTime: number;
  transferredRate: number;
  sla: number;
  lastCallTakenSecond: string;
  callIdsHandledCallsByCQ: string[];
  callIdsTransferredRate: string[];
  totalSLaCalls: number;
  callIdsSLA: string[];
}

// Interface for Agent Metrics (expanded data)
export interface AgentMetricsData {
  id?: number;
  microsoftId?: string;
  displayName: string;
  totalHandledCalls: number;
  totalAnsweredDuration: string;
  averageHandleTime: string;
  transferredRate: number;
  sla: number;
  lastCallTaken: string;
  isExpanded?: boolean;
  isMetricsLoading?: boolean;
  metricsError?: string | null;
  details?: AgentDetail[]; 
}

// API Response for agents list
export interface AgentApiResponse {
  totalCount: number;
  items: AgentItem[];
}

// API Response for agent metrics detail
export interface AgentMetricsResponse {
  agentId: number;
  totalHandledCalls: number;
  totalAnsweredDuration: string;
  averageHandleTime: string;
  transferredRate: number;
  sla: number;
  lastCallTaken: string;
}

export const convertApiToTableData = (agentsData: AgentWithDetails[]): AgentMetricsData[] => {
  return agentsData.map((agent, index) => ({
    id: index + 1,
    displayName: agent.agentName,
    totalHandledCalls: 0, 
    totalAnsweredDuration: "",
    averageHandleTime: "",
    transferredRate: 0,
    sla: 0,
    lastCallTaken: "",
    isExpanded: true,
    isMetricsLoading: false,
    metricsError: null,
    details: agent.details
  }));
};